import React, { useState, useEffect, useContext } from "react";
import AnimePosterSlider from "./AnimePosterSlider";
import AnimeArtistSlider from "./AnimeArtistSlider";
import axios from "axios";
import { Rings } from "react-loader-spinner";

import "./Anime.scss";
import { MovieIndexContext } from "../../context/MovieIndexContext";

const Anime = ({ setValue }) => {
  const [content, setContent] = useState([]);
  const [cast, setCast] = useState([]);
  const [movieId, setMovieId] = useState(0);
  const { loading, setLoading } = useContext(MovieIndexContext);

  const changeEventHandler = (selectedMovieId) => {
    setMovieId(selectedMovieId.activeIndex);

    console.log(selectedMovieId.activeIndex);
  };
  // console.log("movieId", movieId);

  const fetchedMoviesData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=0d5b6447380d8a8161c73ee377404260&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&vote_average.gte=6&with_genres=16`
    );
    // console.log("MovieList", data.results);
    setContent(data.results);
    setLoading(true);
  };

  const fetchedMoviesArtists = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${content[movieId].id}/credits?api_key=0d5b6447380d8a8161c73ee377404260&language=en-US`
    );
    setCast(data?.cast);
    setLoading(true);
  };

  useEffect(() => {
    // console.log("Ddd");
    fetchedMoviesData();
  }, []);
  useEffect(() => {
    if (content.length > 0 && movieId >= 0) fetchedMoviesArtists();
    // eslint-disable-next-line
  }, [movieId, content]);
  // console.log("castParsent", cast);
  // console.log("newdata", content);

  return (
    <div className="animes-tab">
      {loading ? (
        <AnimePosterSlider content={content} movieId={changeEventHandler} />
      ) : (
        <Rings width={1000} height={200} color="#a83119" />
      )}

      <div className="animes-tab__artist-section">
        <div className="animes-tab__best-artists-title">Best Artists</div>
        {loading ? (
          <AnimeArtistSlider cast={cast} />
        ) : (
          <Rings width={1000} height={200} color="#a83119" />
        )}
      </div>
    </div>
  );
};

export default Anime;
